/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CreateBillingCheckoutResponse = zod
	.object({
		session_id: zod.string().describe('Stripe checkout session ID'),
		url: zod.string().describe('Redirect URL for checkout')
	})
	.describe('Billing checkout session details');

export type CreateBillingCheckoutResponse = zod.input<typeof CreateBillingCheckoutResponse>;
export type CreateBillingCheckoutResponseOutput = zod.output<typeof CreateBillingCheckoutResponse>;
